import "../App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { AuthProvider } from "../AuthContext";
import { DashboardProvider } from "../DashboardContext";
import { UserProvider } from "../UserContext";
import UserRouter from "./UserRouter";
import HomeV2 from "./HomeV2";
import ExploreV2 from "./ExploreV2";
import Login from "./Login";

function App() {
  return (
    <Router>
      <AuthProvider>
        <UserProvider>
          <DashboardProvider>
            <Switch>
              <Route exact path="/" component={UserRouter} />
              <Route exact path="/explore" component={ExploreV2} />
              <Route exact path="/login" component={Login} />
              <Route path="*">
                <Redirect to="/" />
              </Route>
            </Switch>
          </DashboardProvider>
        </UserProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
